export const THEME_STORAGE_KEY = 'nur.theme';

const DEFAULT_THEME = 'dark';
const supportedThemes = new Set(['dark', 'light']);

function normalizeTheme(value) {
  return supportedThemes.has(value) ? value : DEFAULT_THEME;
}

function storedTheme() {
  try {
    // Keep the approved preview choice when first moving into the platform.
    return normalizeTheme(window.localStorage.getItem(THEME_STORAGE_KEY) || window.localStorage.getItem('nur.design-preview.ember.theme'));
  } catch {
    return DEFAULT_THEME;
  }
}

function updateThemeColor(theme) {
  document.querySelector('meta[name="theme-color"]')
    ?.setAttribute('content', theme === 'dark' ? '#100e13' : '#eeedf1');
}

export function getTheme() {
  return normalizeTheme(document.documentElement.dataset.theme || storedTheme());
}

export function applyTheme(value, { persist = true } = {}) {
  const theme = normalizeTheme(value);
  document.documentElement.dataset.theme = theme;
  document.documentElement.style.colorScheme = theme;
  updateThemeColor(theme);

  if (persist) {
    try {
      window.localStorage.setItem(THEME_STORAGE_KEY, theme);
    } catch {
      // The visual theme still works when storage is unavailable.
    }
  }

  window.dispatchEvent(new CustomEvent('nur:theme-change', { detail: { theme } }));
  return theme;
}

export function applyRouteTheme(pathname) {
  // Public employee forms are light, without overwriting the user's platform theme.
  return applyTheme(/^\/(register|onboard)\//.test(pathname) ? 'light' : storedTheme(), { persist: false });
}

export function initializeTheme() {
  return applyRouteTheme(window.location.pathname);
}
